import { createFileRoute } from '@tanstack/react-router';
import type { MeetingTemplateKind } from '@wundo/shared/meetingTemplate.ts';
import { MeetingTemplateEditorPage } from '@/components/meeting-templates/MeetingTemplateEditorPage.tsx';
import { meetingTemplateKindFrom } from '@/lib/meetingTemplateKinds.ts';

/* The kind of the card "New" was clicked on, preselected on the form. */
interface NewDefaultSearch {
  kind?: MeetingTemplateKind;
}

export const Route = createFileRoute('/_app/meeting-templates/defaults/new')({
  staticData: { orgScope: 'none' },
  validateSearch: (search: Record<string, unknown>): NewDefaultSearch => ({
    kind: meetingTemplateKindFrom(search.kind),
  }),
  component: NewDefaultRoute,
});

function NewDefaultRoute() {
  return (
    <MeetingTemplateEditorPage scope='defaults' initialKind={Route.useSearch().kind} />
  );
}
